import ReactDOM from 'react-dom';
import preloaded from '../src/preloaded.js';
import RegistrationForm from '../src/registration/RegistrationForm.js';

const target = document.getElementById('app');
if (target) {
  ReactDOM.render(
    <RegistrationForm flow={preloaded.flow} returnTo={preloaded.return_to} />
  , target);
}
